export default __webpack_public_path__ + "static/media/m_quiz_bg_1.9931ae78.png";